define((require) => {
    "use strict";

    const _                     = require("underscore");
    const PolymorphicCollection = require("shared/zbone/PolymorphicCollection");
    const GroupModel            = require("shared/ui/groups/GroupModel");
    const BreakpointGroup       = require("shared/ui/breakpoint/BreakpointGroup");
    const LocalizationGroup     = require("shared/services/localization/LocalizationGroup");
    const RestApi               = require("shared/services/RestApi");

    /**
     * A collection of <tt>GroupModel</tt>'s.
     *
     * @see GroupModel
     *
     * @class GroupCollection
     *
     */
    const GroupCollection = PolymorphicCollection.extend("GroupCollection", {

        constructor(attrs, options) {
            this.__super(attrs, options);

            this.options = options;
        },

        modelTypes() {
            const map = {};

            map[BreakpointGroup.type] = BreakpointGroup;
            map[LocalizationGroup.type] = LocalizationGroup;

            return map;
        },

        defaultModelType: GroupModel,

        url() {
            const assetId = this.options && this.options.assetId;

            if (assetId) {
                return RestApi.pathToSpecificResource(RestApi.Collections.GROUPS_ASSETS, assetId);
            }

            const groupId = this.options && this.options.groupId;

            if (groupId) {
                return RestApi.pathToSpecificResource(RestApi.Collections.GROUPS, groupId);
            }

            return  RestApi.pathToCollection(RestApi.Collections.GROUPS);
        },

        byClass(groupClass) {
            return this.filter((group) => group instanceof groupClass);
        },

        oneByClass(groupClass) {
            return this.byClass(groupClass)[0];
        },

        /**
         * Find a group by an asset id, optionally filtered by the value type.
         *
         * @param {String} id       The asset id, for example experience id
         * @param {String} [type] optional; The value type
         * @returns {GroupModel}    A group model
         */
        findByAssetId(id, type) {
            return this.find((group) => (
                _.find(group.getAssets(), (asset) => {
                    let matchType = true;

                    if (type) {
                        matchType = type === asset.get("type");
                    }

                    return matchType && asset.get("id") === id;
                })
            ));
        },

        /**
         * Returns an array of groups, instances of the specified <tt>groupClass</tt>, if provided, that at least has the specified state.
         *
         * @param  {PublishableState} state The state, as a PublishableState.XXX enum.
         * @param  {Function} groupClass Optional, the group class/constructor function.
         * @return {GroupModel[]}        Array of group models.
         */
        hasAtLeastState(state, groupClass) {
            return this.filter((group) => {
                const hasAtLeastState = group.hasAtLeastState(state);

                if (groupClass) {
                    return hasAtLeastState && group instanceof groupClass;
                }

                return hasAtLeastState;
            });
        }

    }, {

        fetch(options) {
            return new GroupCollection([], options).fetch();
        },

        fetchOne(id, options) {
            const collection = new GroupCollection(null, {groupId: id});

            return collection.fetch(options)
                .then(() => collection.shift());
        },

        /**
         * Fetches the groups containing the asset matching the
         * specified asset id, if any.
         *
         * @param  {String} assetId The id of the asset, e.g. an experience id.
         * @return {Promise}        A promise that resolves with a <tt>GroupCollection</tt> instance
         *                          containing the groups that refers the specified asset.
         */
        byAssetId(assetId) {
            return new GroupCollection([], {assetId}).fetch();
        },

        parse(json) {
            const collection = new GroupCollection();
            return collection.model(json, {collection});
        }
    });

    return GroupCollection;
});



// WEBPACK FOOTER //
// ./src/shared/ui/groups/GroupCollection.js